export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12055.beb4c70c.jpg";